import { render, staticRenderFns } from "./ProductsReport.vue?vue&type=template&id=47ac62c8&"
import script from "./ProductsReport.vue?vue&type=script&lang=js&"
export * from "./ProductsReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductsReport.vue?vue&type=style&index=0&id=47ac62c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports